import Button from "@/components/ui/buttons/Button/Button";
import styles from "./Hero.module.scss";
import BlazeSlider from "blaze-slider";
import { CldImage } from "next-cloudinary";
import BlazeSlide from "@/components/Slider/BlazeSlider/BlazeSlide/BlazeSlide";
import useWindowSize from "lib/hooks/useWindowSize";

export default function Hero({
  title,
  images,
  mode = "single",
  link,
  buttonText,
  children,
}) {
  return (
    <section className={`${styles.container} ${styles[mode]}`}>
      {mode === "single" && images?.length && (
        <SingleImageHero
          image={images[0].url}
          imageAlt={images[0].alt}
          title={title}
          buttonText={buttonText}
          link={link}
        >
          {children}
        </SingleImageHero>
      )}
      {mode === "slider" && <SliderHero>{children}</SliderHero>}
    </section>
  );
}

function SingleImageHero({
  image,
  imageAlt,
  title,
  link,
  buttonText,
  children,
}) {
  const windowSize = useWindowSize();

  return (
    <div className={`${styles.heroContent}`}>
      <div className={`${styles.content} variable-container`}>
        {title && <p className={`${styles.title}`}>{title}</p>}
        {link && (
          <div className={`${styles.buttonWrapper}`}>
            <Button
              link={link}
              type="primary"
              customStyles={{ fontSize: "var(--font-size-md-sm)" }}
              classes={["hero-cta"]}
            >
              {buttonText}
            </Button>
          </div>
        )}
      </div>
      {children}
      <div className={`${styles.imageWrapper}`}>
        {image && (
          <CldImage
            src={image}
            alt={title}
            loading="eager"
            width={windowSize?.width <= 768 ? 868 : 1520}
            height={windowSize?.width <= 768 ? 868 : 850}
            crop={windowSize?.width > 768 ? `lfill,ar_1.78` : `lfill,ar_0.56`}
            className={`${styles.image}`}
            sizes="
          (max-width: 640px) 640px,
          (max-width: 768px) 100vw,
          (min-width: 768px) 1200px
        "
          />
        )}
      </div>
    </div>
  );
}

function SliderHero({ images, children }) {
  const slides = images?.map((image) => {
    const slide = <BlazeSlide imageURL={image.url} alt={image.alt} />;
  });

  return <BlazeSlider>{slides}</BlazeSlider>;
}
